import { useEffect, useRef, useCallback } from 'react';

export function usePullToRefresh(onRefresh: () => Promise<void> | void) {
  const startY = useRef(0);
  const pulling = useRef(false);
  const refreshing = useRef(false);

  const handleTouchStart = useCallback((e: TouchEvent) => {
    if (refreshing.current) return;
    // Only trigger when scrolled to top
    const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    if (scrollTop > 5) return;
    startY.current = e.touches[0].clientY;
    pulling.current = true;
  }, []);

  const handleTouchEnd = useCallback(async (e: TouchEvent) => {
    if (!pulling.current || refreshing.current) return;
    pulling.current = false;

    const endY = e.changedTouches[0].clientY;
    const diff = endY - startY.current;

    if (diff > 80) {
      refreshing.current = true;
      try {
        await onRefresh();
      } finally {
        refreshing.current = false;
      }
    }
  }, [onRefresh]);

  useEffect(() => {
    document.addEventListener('touchstart', handleTouchStart, { passive: true });
    document.addEventListener('touchend', handleTouchEnd, { passive: true });
    return () => {
      document.removeEventListener('touchstart', handleTouchStart);
      document.removeEventListener('touchend', handleTouchEnd);
    };
  }, [handleTouchStart, handleTouchEnd]);
}
